import { SelectTrigger } from '@/components/ui/select';
import { cn } from '@/lib/utils';

type SelectTriggerLabelProps = {
  children: React.ReactNode;
  className?: string;
  label: string;
};

export const SelectTriggerLabel = ({
  children,
  className,
  label,
}: SelectTriggerLabelProps) => {
  return (
    <SelectTrigger className={cn('h-14', className)}>
      <p className='flex flex-col items-start text-base leading-5'>
        <span className='text-xs text-black/50'>{label}</span>
        {children}
      </p>
    </SelectTrigger>
  );
};
